module.exports = __webpack_public_path__ + "static/media/21.2140afa5.mp3";